<template>
  <div class="ion-page">
    <ion-header class="ion-no-border" v-if="form.banner">
      <div
        class="form-landing-banner"
        :style="{
          'background-image': 'url(' + getSrc(form.banner.key) + ')'
        }"
      ></div>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-grid>
        <ion-row>
          <ion-col>
            <div class="text-center">
              <h1 class="form-landing-title" v-if="form.title">
                {{ form.title }}
              </h1>
              <h4 class="form-landing-subtitle" v-if="form.subtitle">
                {{ form.subtitle }}
              </h4>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
    <ion-footer class="ion-no-border">
      <ion-toolbar class="ion-no-border">
        <div class="ion-padding text-center">
          <div class="text-container">
            <ion-note>Powered by StayOnHire</ion-note>
          </div>
          <ion-button expand="block" @click="onStart">{{
            form.button_text
          }}</ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "FormLanding",
  props: ["form"],
  methods: {
    formatDate(iso) {
      return DateTime.fromISO(iso).toFormat("d LLL y, hh:mm a");
    },
    getSrc(key) {
      return process.env.VUE_APP_USERCONTENT_ORIGIN + `/${key}`;
    },
    onStart() {
      this.$emit("start");
    }
  }
};
</script>

<style lang="scss" scoped>
.form-landing {
  &-title {
    font-weight: bold;
  }
  &-banner {
    height: 36vh;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  &-last {
    font-size: 0.9em;
  }
}
</style>
